import t, { forwardRef as j, useState as I, useEffect as R, isValidElement as O } from "react";
import { Flex as $ } from "../Flex/Flex.js";
import { isEmpty as s } from "../../helpers/stringHelper.js";
import { cls as p } from "../../helpers/cls.js";
import { dropdownDefaultProps as h } from "./props.js";
import { ChevronDown as L } from "@olxbr/ds-icons";
import { Spinner as A } from "../Spinner/Spinner.js";
import { useUniqueId as B } from "../../hooks/useUniqueId.js";
import { FormControlLabel as M, FormControlErrorORCaption as q } from "../FormControl/FormControl.js";
var k = Object.defineProperty,
  Q = Object.defineProperties,
  W = Object.getOwnPropertyDescriptors,
  u = Object.getOwnPropertySymbols,
  N = Object.prototype.hasOwnProperty,
  S = Object.prototype.propertyIsEnumerable,
  V = (r, e, o) => e in r ? k(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : r[e] = o,
  _ = (r, e) => {
    for (var o in e || (e = {})) N.call(e, o) && V(r, o, e[o]);
    if (u) for (var o of u(e)) S.call(e, o) && V(r, o, e[o]);
    return r;
  },
  G = (r, e) => Q(r, W(e)),
  H = (r, e) => {
    var o = {};
    for (var a in r) N.call(r, a) && e.indexOf(a) < 0 && (o[a] = r[a]);
    if (r != null && u) for (var a of u(r)) e.indexOf(a) < 0 && S.call(r, a) && (o[a] = r[a]);
    return o;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const T = '[Dropdown - Accessibility Error] O elemento select deve ter um label associado. Informe pelo menos um dos atributos "label" | "aria-label" | "aria-labelledby" com valor v\xE1lido.',
  U = '[Dropdown - Accessibility Error] Quando o state for "loading" \xE9 obrigat\xF3rio informar um "stateMessage" para indicar para os leitores de tela a mensagem de carregamento.',
  Y = "[Dropdown - Error] Para utiliza\xE7\xE3o da label no componente \xE9 obrigat\xF3rio a utiliza\xE7\xE3o de um id v\xE1lido.",
  J = _ref => {
    let {
      "aria-label": r,
      "aria-labelledby": e,
      label: o,
      state: a,
      stateMessage: f
    } = _ref;
    if (!O(o) && typeof o == "string" && s(o) && s(r) && s(e)) throw new Error(T);
    if (a === "loading" && s(f)) throw new Error(U);
  },
  K = _ref2 => {
    let {
      id: r,
      label: e
    } = _ref2;
    if (!O(e) && typeof e == "string" && s(r)) throw new Error(Y);
  },
  X = _ref3 => {
    let {
      items: r,
      placeholder: e,
      required: o
    } = _ref3;
    return t.createElement(t.Fragment, null, e && t.createElement("option", {
      key: "-1",
      value: "",
      label: e,
      disabled: o
    }, e), r == null ? void 0 : r.map(a => t.createElement("option", _({
      key: a.label
    }, a), a.label)));
  },
  v = j((r, e) => {
    var o = r,
      {
        iconLeft: a,
        items: f,
        state: n,
        stateMessage: c,
        caption: P,
        size: m,
        label: z,
        className: C
      } = o,
      l = H(o, ["iconLeft", "items", "state", "stateMessage", "caption", "size", "label", "className"]),
      E,
      b;
    const [x, w] = I((E = l.defaultValue) != null ? E : l.value),
      g = B("ds-dropdown-error"),
      i = m != null ? m : h.size,
      F = m === "medium" ? 24 : 16;
    R(() => {
      var d, D;
      ((d = l.defaultValue) != null ? d : l.value) ? w((D = l.defaultValue) != null ? D : l.value) : w("");
    }, [l.defaultValue, l.value]), J(l), K(l);
    const y = n === "error" && !!c;
    return t.createElement($, {
      "data-ds-component": "DS-Dropdown",
      flexDirection: "column"
    }, t.createElement(M, {
      htmlFor: l.id,
      size: m,
      marginBottom: "--spacing-1"
    }, z), t.createElement("div", {
      className: p("olx-dropdown__wrapper", "olx-dropdown__wrapper--".concat(i))
    }, a && t.createElement("span", {
      className: p({
        "olx-dropdown__icon-wrapper": !0,
        ["olx-dropdown__icon-wrapper--".concat(i)]: !0,
        "olx-dropdown__icon-wrapper--selected": !!x
      })
    }, a), t.createElement("select", G(_({
      className: p({
        "olx-dropdown__native": !0,
        ["olx-dropdown__native--".concat(i)]: !0,
        "olx-dropdown__native--selected": !!x,
        "olx-dropdown__native--error": n === "error",
        "olx-dropdown__native--icon-left": !!a,
        ["olx-dropdown__native--icon-left--".concat(i)]: !!a
      }, C)
    }, l), {
      "aria-busy": n === "loading",
      "aria-errormessage": n === "error" ? g : void 0,
      "aria-invalid": n === "error",
      defaultValue: (b = l.defaultValue) != null ? b : void 0,
      onChange: d => {
        w(d.target.value), l.onChange && l.onChange(d);
      },
      ref: e
    }), t.createElement(X, _({
      items: f
    }, l))), n === "loading" && c ? t.createElement(A, {
      className: p("olx-dropdown__loading-icon", "olx-dropdown__loading-icon--".concat(i)),
      "aria-label": c,
      size: "extra-small"
    }) : t.createElement(L, {
      className: p({
        "olx-dropdown__chevron-icon": !0,
        ["olx-dropdown__chevron-icon--".concat(i)]: !0,
        "olx-dropdown__chevron-icon--disabled": l.disabled
      }),
      size: F
    })), t.createElement(q, {
      marginTop: "--spacing-1",
      hasError: y,
      id: g
    }, y ? c : P));
  });
v.defaultProps = h, v.displayName = "DS-Dropdown";
export { v as Dropdown };